import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { incrementAnomaliesNumber } from '../EditTicket/EditTicketSlice';

import useStyles from './styles';

export default function AddAnomaly() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function addNewAnomaly() {
    dispatch(incrementAnomaliesNumber());
  }

  return (
    <Accordion className={classes.addAnomalyAccordion}>
      <div
        role="button"
        tabIndex={0}
        className={classes.root}
        onClick={addNewAnomaly}
        onKeyDown={addNewAnomaly}
      >
        <Typography className={classes.AddAnomalyHeading}>
          {t('Anomaly')}
        </Typography>
        <Typography className={classes.addAnomalySecondaryHeading}>
          {t('Add new Anomaly')}
        </Typography>
        <IconButton aria-label="plus" className={classes.plusButton}>
          <AddIcon className={classes.largeIcon} />
        </IconButton>
      </div>{' '}
    </Accordion>
  );
}
